import { VendorRentalApprovalDetailPage } from "@/features/vendor-consignment-rental-payment/pages/VendorRentalApprovalDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/vendor-rental-approval/$id/detail")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: VendorRentalApprovalDetailPage,
});
